/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import {
  Text,
  View,
  Image,
} from '@react-pdf/renderer';

import separatorLine from '../assets/images/line.png';
import horizontalInitioLogo from '../assets/images/horizontal-initio-logo.png';
import bottomLogoRedwood from '../assets/images/BottomLogoRedwood.png';

/**
 * test
 * BottomPagination component for PDF report pages
 * Displays page numbers and tenant-specific branding (copyright text and logo)
 * @param {number} pageNumberLeft - Left page number (odd-numbered pages)
 * @param {number} pageNumberRight - Right page number (even-numbered pages)
 * @param {string} brandNameCapitalized - Tenant brand name (e.g., "Redwoodseed" or "Initio") for copyright text
 * @param {string} tenant - Tenant identifier ('redwoodseed' or 'initio') for logo selection
 */
export default function BottomPagination({
  pageNumberLeft,
  pageNumberRight,
  brandNameCapitalized,
  tenant,
  reportBottomText,
}) {
  // Select logo based on tenant - ensures correct branding on all pages
  // Defaults to initio logo if tenant is not provided or not redwoodseed
  const horizontalLogo = tenant === 'redwoodseed' ? bottomLogoRedwood : horizontalInitioLogo;
  // Apply different height for redwoodseed logo
  const logoHeight = tenant === 'redwoodseed' ? '25px' : '16px';

  return (
    <>
      <View
        style={{
          position: 'absolute',
          bottom: '0px',
          height: '36px',
          width: '100%',
          paddingLeft: '32px',
          paddingRight: '32px',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
        }}
      >
        {/* Left page number (odd-numbered pages) */}
        <Text
          style={{
            fontFamily: 'Roboto',
            fontSize: '12px',
            color: '#79747E',
            marginRight: '25px',
          }}
        >
          {pageNumberLeft}
        </Text>
        {/* Copyright text with tenant-specific branding - shows on left side of odd-numbered pages */}
        <Text
          style={{
            fontFamily: 'Roboto',
            fontSize: '8px',
            letterSpacing: '0.4px',
            color: '#79747E',
          }}
        >
          ©
          {new Date().getFullYear()}
          {' '}
          {reportBottomText}. All rights reserved.
        </Text>
        {/* Tenant-specific logo - shows on right side of all pages */}
        <Image
          src={horizontalLogo}
          style={{
            width: '110px',
            height: logoHeight,
            marginLeft: 'auto',
            marginRight: '14px',
          }}
        />
        {/* Right page number (even-numbered pages) */}
        <Text
          style={{
            fontFamily: 'Roboto',
            fontSize: '12px',
            color: '#79747E',
          }}
        >
          {pageNumberRight}
        </Text>
      </View>
      <Image
        src={separatorLine}
        style={{
          position: 'absolute',
          width: '100%',
          bottom: '34px',
        }}
      />
    </>
  );
}

BottomPagination.propTypes = {
  pageNumberLeft: PropTypes.number,
  pageNumberRight: PropTypes.number,
  brandNameCapitalized: PropTypes.string, // Tenant brand name for copyright text (e.g., "Redwoodseed" or "Initio")
  tenant: PropTypes.string, // Tenant identifier for logo selection ('redwoodseed' or 'initio')
  reportBottomText: PropTypes.string,
};
